<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title :title="pageTitle" />
          <hr />

          <b-alert v-if="isSubmitted" show variant="success">
            <p>Thank you. <b>Your letter of support has been submitted.</b></p>
            <p>You may close this window, or make additional edits to your letter.</p>
          </b-alert>

          <b-alert v-if="isComplete && isSubmitted" show variant="success">
            <p>Your letter of support has already been electronically signed and submitted. Thank you.</p>
          </b-alert>

          <div v-if="status == 'Loading'">
            Please wait, loading...
          </div>

          <div v-if="status == 'Invalid'">
            The link you followed is invalid.
          </div>

          <div v-if="status == 'Form'">
            <content-block slug="supporter-header" :tokens="landingData" />

            <b-form @submit.prevent="onSubmit">

              <textarea-control v-model="submission.supportText" :disabled="isComplete" />

              <text-control label="Your Name" v-model="submission.signatureName" required :disabled="isComplete" description="The name provided here is the name that will be included in your electronic signature."></text-control>
              <checkbox-control label="Electronically Sign" required :disabled="isComplete" v-model="isSigned"></checkbox-control>

              <div class="mt-3">
                <b-button type="submit" variant="primary" :disabled="isComplete">Submit to Attorney</b-button>
              </div>

            </b-form>            

          </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import AuthMixin from '../Mixins/AuthMixin.vue';
import FormMixin from '../Mixins/FormMixin.vue';
import axios from "axios";

export default {
  name: "SupporterLanding",
  mixins: [
    AuthMixin,
    FormMixin
  ],
  props: [
    'shortCode'
  ],
  data() {
    return {
      landingData: null,
      submission: null,
      isSubmitted: false,
      isSigned: false
    }
  },
  computed: {
    status: function () {
      if (!this.landingData)
        return 'Loading';
      else if (!this.landingData.isValidShortCode)
        return 'Invalid';
      else
        return 'Form';
    },
    pageTitle: function () {
      return 'Welcome';
    },
    isComplete: function () {
      return this.isSubmitted || (this.submission && this.submission.isComplete);
    }
  },
  methods: {
    load: function () {
      axios
        .get('/api/supporter/landingData?shortCode=' + this.shortCode)
        .then(response => {
          this.landingData = response.data;
          this.submission = this.landingData.submission;
        })
        .catch(error => {
          console.log(error);
        });    
    },
    onSubmit: function () {
      if (this.isFormValid()) {
        axios
          .post('/api/supporter/submit', this.submission)
          .then(response => {
            this.submission = response.data;

            this.isSubmitted = true;

            window.scrollTo(0, 0);
          })
          .catch(error => {
            console.log(error);
          });    
      }
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();
  }
};
</script>